import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isTruncatedByCss'
})
export class IsTruncatedByCssPipe implements PipeTransform {
  transform(offsetDimension: number, scrollDimension: number): boolean {
    return offsetDimension < scrollDimension;
  }
}
